import React from "react";
import { Switch, Route } from "react-router-dom";
import Main from "../containers/mainContainer"
import New from "../containers/newContainer"
import PlanConfigByStep from "../containers/planConfigByStepContainer"


function RouterPlanTemplate() {
    return (
        <Route path="/">
            <Route path="/PlanTemplate">
                <Switch>
                    <Route path="/PlanTemplate" exact>
                        <Main />
                    </Route>
                    <Route path="/PlanTemplate/Main" exact>
                        <Main />
                    </Route>
                    <Route path="/PlanTemplate/New" exact>
                        <New />
                    </Route>
                    <Route path="/PlanTemplate/Edit/:id" exact>
                        <New />
                    </Route>
                    <Route path="/PlanTemplate/New/PlanConfigByStep" exact>
                        <PlanConfigByStep />
                    </Route>
                    <Route path="/PlanTemplate/Edit/:id/PlanConfigByStep" exact>
                        <PlanConfigByStep />
                    </Route>
                </Switch>
            </Route>
            {/* <Route path="/" exact>
                <Main />
            </Route> */}
        </Route>

    );
}
export default RouterPlanTemplate;
